import {Component, forwardRef, Injector, Input} from "@angular/core";
import {ColumnComponent} from "../../../../framework/entity/grid/column.component";
import {AbstractColumnComponent} from "../../../../framework/entity/grid/abstract-column.component";
import {Markup_Type, Markup_Value_Type, MarkupData} from "../../markup.data";

/**
 * Search grid column to render currency/percent values
 */
@Component({
    selector: "wbo-markup-value-column",
    templateUrl: "./markup-value-column.component.html",
    styleUrls: ["./markup-value-column.component.scss"],
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => MarkupValueColumnComponent), multi: true}
    ]
})
export class MarkupValueColumnComponent extends AbstractColumnComponent {
    @Input() markupField: string;
    @Input() markupTypeField: string;

    Markup_Value_Type = Markup_Value_Type;

    constructor(injector: Injector) {
        super(injector);
    }

    getMarkupValueType(dataItem: any): Markup_Value_Type {
        return this.markupField ? dataItem[this.markupField].getValueType() :
            this.markupTypeField ? MarkupData.getValueType(Markup_Type[Markup_Type[dataItem[this.markupTypeField]]]) :
            Markup_Value_Type.CURRENCY;
    }

    getNotation(dataItem: any): string {
        const markupValueType: Markup_Value_Type = this.getMarkupValueType(dataItem);
        return markupValueType == Markup_Value_Type.CURRENCY ? "wbo.common.currencyCode" :
            markupValueType == Markup_Value_Type.PERCENT ? "wbo.common.percent" :
                "wbo.common.empty";
    }
}
